import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProjectModel } from 'model/ProjectModel'
import { newProjectActions } from '../newProjectReducer'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'

export const saveOrderNumber = createAsyncThunk<any, any, { state: any }>(
  'project/saveOrderNumber',
  async (orderNumber: string, thunkAPI) => {
    const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

    thunkAPI.dispatch(
      newProjectActions.setActiveProjectProperties({
        orderNumber: orderNumber,
      } as Partial<ProjectModel>)
    )

    try {
      return await api.SetOrderNumber(projectId, orderNumber)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
